module.exports = __webpack_public_path__ + "static/media/CT_2019_30448A_pdf.9b376665.pdf";